export default {
  upsertInStore(data, model, dataType) {
    try {
      if (
        dataType == "Meeting" ||
        dataType == "MeetingResolution" ||
        dataType == "Mandate" ||
        dataType == "ResolutionVote"
      ) {
        this.conditionallyUpdateData(data, model);

        return;
      }

      model.insertOrUpdate({
        data: data,
      });
    } catch (err) {
      console.error(err);
    }
  },
  deleteFromStore(dataId, model) {
    model.delete(dataId);
  },

  // helpers
  // !!!: similar functions are used in AG app too.. make changes there also if you change something here
  conditionallyUpdateData(data, model) {
    const fieldsToCompare = Object.keys(data);
    const previousData = model.find(data.id);

    if (previousData) {
      if (this.dataDiffersFromPrevious(data, previousData, fieldsToCompare)) {
        model.update({
          where: data.id,
          data: data,
        });
      }
    } else {
      model.insert({ data });
    }
  },
  dataDiffersFromPrevious(data, previousData, fields) {
    for (const field of fields) {
      if (typeof previousData[field] != "undefined") {
        let newValue = data[field];
        let oldValue = previousData[field];
        if (typeof newValue == "object") {
          newValue = JSON.stringify(newValue);
          oldValue = JSON.stringify(oldValue);
        }

        if (newValue != oldValue && !this.ignoreFieldComparison(field)) {
          return true;
        }
      }
    }
    return false;
  },
  ignoreFieldComparison(field) {
    const generalIgnoredFields = ["@context", "@type", "@id", "created", "updated", "deleted"];
    const mandateIgnoredFields = ["last_seen"];
    const meetingIgnoredFields = ["minutes"];
    return generalIgnoredFields.concat(mandateIgnoredFields, meetingIgnoredFields).includes(field);
  },
};
